import { render, staticRenderFns } from "./Award.vue?vue&type=template&id=a8afc7c4&scoped=true"
import script from "./Award.vue?vue&type=script&lang=js"
export * from "./Award.vue?vue&type=script&lang=js"
import style0 from "./Award.vue?vue&type=style&index=0&id=a8afc7c4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8afc7c4",
  null
  
)

export default component.exports